import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import * as actions from '../Actions';
import { fetchInitialData, fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import FaqsDisclaimer from '../common/FaqsDisclaimer';
import Service from '../../service/Service';
import Swiper from 'swiper';
import HowFeed from "./HowFeed";
import CommunityFeed from "./CommunityFeed";
import withLocation from "../../../withLocation";
import './Feed.css'
const service = new Service();

class DueDateDetails extends Component {
    constructor(props) {
        super(props);
        console.log("*********DueDateDetails component loaded*************");

        let initialData = [];
        let articlesData = [];
        let dueDate = "";
        let pregnancyWeek = ""

        
        if (typeof window !== 'undefined' && window.__initialData__) {
            // ✅ Browser-side
            const data = window.__initialData__;
          
            if (data.initialData && data.initialData.result) {
              initialData = data.initialData.result;
            }
            if (data.initialData && data.initialData.articles) {
              articlesData = data.initialData.articles;
            }
          
            dueDate = initialData[0].dueDate || "";
            pregnancyWeek = initialData[0].pregnancyWeek || "";
          
            console.log("initialData in browser:", initialData);
            delete window.__initialData__; // Prevent reuse
          
          } else if (props.staticContext) {
            // ✅ Server-side
            const staticData = props.staticContext.initialData;
          
            if (staticData?.initialData?.result) {
              initialData = staticData.initialData.result;
            }
            if (staticData?.initialData?.articles) {
              articlesData = staticData?.initialData?.articles;
            }
          
            dueDate = initialData[0]?.dueDate || "";
            pregnancyWeek = initialData[0]?.pregnancyWeek || "";
          
            console.log("initialData in server:", initialData);
          }
        this.state = {
            FirstDateOfLMP: '',
            avgCycleDays: '',
            conceptionDate: '',
            displayDate: '',
            loggedin: false,
            IsExpected: false,
            showConfirmation: false,
            communityHome:[],
            highlights : [],
            pageNo: 1, 
            loadingMore: false, // 👈 Prevent multiple calls during loading
            hasMore: true, // ✅ Important flag
            dueDate: dueDate || "",
            pregnancyWeek: pregnancyWeek || "",
            selectedMethod: "",
            initialData: initialData || [],
            articlesData: articlesData || [],
            dueDateForm: {
              conceptionDate: "",
              FirstDateOfLMP: "",
              avgCycleDays: "",
              ultrasoundDate: "",
              ultrasoundAge: "",
              ivftransferDate: "",
              embryoTransfer: ""
            }
        }
        this.highlightsScrollRef = React.createRef();
        this.communityFeedScrollRef = React.createRef();
    }
    // static initialAction(reqUrl, ftk, authData, uId) {
    //     const { URL } = require('url');
      
    //     // Step 1: Create full URL (add base for parsing)
    //     const fullUrl = new URL(reqUrl, 'http://localhost'); // base URL can be any valid URL
      
    //     // Step 2: Extract query params
    //     const method = fullUrl.searchParams.get("method");
    //     const FirstDateOfLMP = fullUrl.searchParams.get("FirstDateOfLMP");
    //     const avgCycleDays = fullUrl.searchParams.get("avgCycleDays");
    //     const conceptionDate = fullUrl.searchParams.get("conceptionDate");
    //     const ultrasoundDate = fullUrl.searchParams.get("ultrasoundDate");
    //     const ultrasoundWeek = fullUrl.searchParams.get("ultrasoundWeek");
    //     const ultrasoundDays = fullUrl.searchParams.get("ultrasoundDays");
    //     const ivftransferDate = fullUrl.searchParams.get("ivftransferDate");
    //     const embryoTransfer = fullUrl.searchParams.get("embryoTransfer");
    //     const isNewEntry = parseInt(fullUrl.searchParams.get("isNewEntry") || "1");
      
    //     // Step 3: Rebuild body object for API
    //     const body = { isNewEntry };
      
    //     if (FirstDateOfLMP) {
    //       body.FirstDateOfLMP = FirstDateOfLMP;
    //     }
    //     if (avgCycleDays) {
    //       body.avgCycleDays = parseInt(avgCycleDays);
    //     }
    //     if (conceptionDate) {
    //       body.conceptionDate = conceptionDate;
    //       body.FirstDateOfLMP = ""; // fallback logic
    //     }
    //     if (ultrasoundDate && ultrasoundWeek && ultrasoundDays) {
    //       body.ultrasoundDate = ultrasoundDate;
    //       body.ultrasoundAge = {
    //         week: parseInt(ultrasoundWeek),
    //         days: parseInt(ultrasoundDays),
    //       };
    //     }
    //     if (ivftransferDate && embryoTransfer) {
    //       body.ivftransferDate = ivftransferDate;
    //       body.embryoTransfer = embryoTransfer;
    //     }
      
    //     console.log("SSR Parsed Method:", method);
    //     console.log("SSR Request Body:", body);
    //     var header = {
    //         'Content-Type': 'application/json',
    //         'ftk': ftk,
    //         'uid': uId,
    //         'access-token': authData['access-token'],
    //         'user-agent': global.userAgent,
    //         'isdesktop': global.isdesktop
    //     }
    //     var url = global.api_url + "duedate/getduedatedetails_v1";
    //     return fetchInitialData(url, JSON.stringify(header), body);
    // }
    static initialAction(reqUrl, ftk, authData, uId) {
        console.log("🔍 Received SSR URL:1", reqUrl);

        const { URL } = require("url");

        // Example: simulate SSR `reqUrl`

        // Step 1: Create full URL
        const fullUrl = new URL(reqUrl, "http://localhost"); // Needed to parse relative paths
        console.log("✅ Parsed full SSR URL:", fullUrl.href);

        // Step 2: Extract pathname
        const pathname = fullUrl.pathname;
        const pathSegments = pathname.split("/").filter(Boolean); // remove empty strings

        console.log("📂 Path Segments:", pathSegments);

        // Step 3: Extract method and values from known pattern
        // Expecting: [ 'tools', 'pregnancy-due-date-calculator', 'details', ':method', ':param1', ':param2', ... ]
        const method = decodeURIComponent(pathSegments[3] || "");
        let body = { isNewEntry: 1 };

        switch (method) {
          case "Last-Period":
            body.FirstDateOfLMP = pathSegments[4] || "";
            body.avgCycleDays = parseInt(pathSegments[5] || "28");
            break;
        
          case "Ultrasound-Method":
            body.ultrasoundDate = pathSegments[4] || "";
            body.ultrasoundAge = {
              week: parseInt(pathSegments[5] || "0"),
              days: parseInt(pathSegments[6] || "0"),
            };
            break;
          
          case "IVF-Method":
            body.ivftransferDate = pathSegments[4] || "";
            body.embryoTransfer = decodeURIComponent(pathSegments[5] || "");
            break;
          
          case "Conception-Method":
            body.conceptionDate = pathSegments[4] || "";
            break;
          
          default:
            console.warn("⚠️ Unrecognized method in path:", method);
            break;
        }

        console.log("🧾 Final Parsed Method:", method);
        console.log("📤 Final Request Body:", body);

        // Step 4: Header setup
        const header = {
          'Content-Type': 'application/json',
          'ftk': ftk,
          'uid': uId,
          'access-token': authData['access-token'],
          'user-agent': global.userAgent,
          'isdesktop': global.isdesktop
        };
      
        const url = global.api_url + "duedate/getduedatedetails_v1";
      
        console.log("🌐 Hitting SSR API:", url);
        console.log("📨 Headers:", header);
      
        // Step 5: Return API call for SSR
        return fetchInitialData(url, JSON.stringify(header), JSON.stringify(body));
      }
      
    componentDidMount() {
        // if (!global.ftk) {
        //     window.location.href = service.getRedirectUrl("/tools/pregnancy-due-date-calculator/");
        // }
        console.log("DueDateDetails componentDidMount called");

        const path = this.props.location.pathname;
        const pathSegments = path.split("/tools/pregnancy-due-date-calculator/details/")[1]
          ?.split("/")
          .filter(Boolean);

        const method = decodeURIComponent(pathSegments?.[0] || "");
        let lmp = "", cycle = "", conception = "", ultrasoundDate = "", ultrasoundWeek = "", ultrasoundDays = "", ivfDate = "", embryoTransfer = "";

        console.log("🔍 Extracted method:", method);

        switch (method) {
          case "Last-Period":
            lmp = pathSegments[1] || "";
            cycle = pathSegments[2] || "28";
            break;
        
          case "Ultrasound-Method":
            ultrasoundDate = pathSegments[1] || "";
            ultrasoundWeek = pathSegments[2] || "0";
            ultrasoundDays = pathSegments[3] || "0";
            break;
        
          case "IVF-Method":
            ivfDate = pathSegments[1] || "";
            embryoTransfer = decodeURIComponent(pathSegments[2] || "");
            break;
        
          case "Conception-Method":
            conception = pathSegments[1] || "";
            break;
        
          default:
            console.warn("⚠️ Unknown method type in path.");
        }

        // ✅ Final extracted values
        console.log("method:::", method);   
        console.log("lmp:::", lmp);
        console.log("cycle:::", cycle);
        console.log("conception:::", conception);
        console.log("ultrasoundDate:::", ultrasoundDate);
        console.log("ultrasoundWeek:::", ultrasoundWeek);
        console.log("ultrasoundDays:::", ultrasoundDays);
        console.log("ivfDate:::", ivfDate);
        console.log("embryoTransfer:::", embryoTransfer);

        this.setState({
            selectedMethod: method || "",
            dueDateForm: {
              FirstDateOfLMP: lmp || "",
              avgCycleDays: cycle || "",
              conceptionDate: conception || "",
              ultrasoundDate: ultrasoundDate || "",
              ultrasoundAge: (ultrasoundWeek && ultrasoundDays)
              ? { week: parseInt(ultrasoundWeek), days: parseInt(ultrasoundDays) }
              : { week: 0, days: 0 },
              ivftransferDate: ivfDate || "",
              embryoTransfer: embryoTransfer || "",
            //   method: method || ""
            }
          }, () => {
            console.log("State set from query params:", this.state);
          });
        


        // let qUrl = this.props.match.url.split('/');
        // this.state.FirstDateOfLMP = qUrl[4];
        // this.state.avgCycleDays = qUrl[5];
        // this.state.conceptionDate = qUrl[6];
        // if (this.state.FirstDateOfLMP == 0) {
        //     this.state.displayDate = this.state.conceptionDate;
        // } else if (this.state.conceptionDate == 0) {
        //     this.state.displayDate = this.state.FirstDateOfLMP;
        // }
        // if (global.userAry['IsExpected'] || global.ftk != '') {
        //     this.setState({ IsExpected: true, loggedin: true });
        //     console.log("componentDidMount ====> true ");
        // } else {
        //     this.setState({ IsExpected: false, loggedin: false });
        // }
        // if (navigator.onLine) {
        //     if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
        //         service.showLoader();
        //         this.getDueDateCalculation();
        //     } else {
        //         console.log("initialData already exists in state, skipping API call");
        //         // localStorage.setItem('initialData', JSON.stringify(this.state.initialData));
        //         // this.setWidth();
        //         // this.landDueDatePage();
        //     }
        // } else {
        //     if (localStorage.getItem('initialData')) {
        //         this.setState({ initialData: JSON.parse(localStorage.getItem('initialData')) });
        //         this.setWidth();
        //         // this.landDueDatePage();
        //     }
        //     service.hideLoader();
        // }


        this.getDueDateCalculation();
        this.initSwipers();
        this.setPositionofTabs(this.state.dueDate);
    }
    setWidth() {
        if (window.innerWidth > 767) {
            let allArticle = document.getElementsByClassName("duedatedetail-article");
            for (let i = 0; i < allArticle.length; i++) {
                let index = allArticle[i].getAttribute("data-id");
                let article_length = document.querySelector(".article_" + index).lastChild.firstElementChild.children.length;
                document.querySelector(".article_" + index).lastChild.firstElementChild.style.width = ((article_length * 480) + ((article_length - 1) * 10)) + "px";
            }
        } else {
            var allArticle = document.getElementsByClassName("duedatedetail-article");
            for (var i = 0; i < allArticle.length; i++) {
                var index = allArticle[i].getAttribute("data-id");
                var article_length = document.querySelector(".article_" + index).lastChild.firstElementChild.children.length;
                document.querySelector(".article_" + index).lastChild.firstElementChild.style.width = ((article_length * 255) + ((article_length - 1) * 10)) + "px";
            }
        }
    }
    getDueDateCalculation = () => {
      // 1️⃣ Extract path segments from current route
      const pathSegments = this.props.location.pathname
        .split("/tools/pregnancy-due-date-calculator/details/")[1]
        ?.split("/")
        .filter(Boolean);
    
      console.log("🔍 Extracted Path Segments:", pathSegments);
    
      if (!pathSegments || pathSegments.length === 0) return;
    
      const method = decodeURIComponent(pathSegments[0]); // e.g., 'Last-Period'
    
      let body = { isNewEntry: 1 };
      let dueDateForm = {
        FirstDateOfLMP: "",
        avgCycleDays: "",
        conceptionDate: "",
        ultrasoundDate: "",
        ultrasoundAge: { week: 0, days: 0 },
        ivftransferDate: "",
        embryoTransfer: ""
      };
    
      // 2️⃣ Map values based on method
      switch (method) {
        case "Last-Period":
          dueDateForm.FirstDateOfLMP = pathSegments[1] || "";
          dueDateForm.avgCycleDays = pathSegments[2] || "28";
    
          if (!dueDateForm.FirstDateOfLMP) return alert("LMP date missing");
    
          body = {
            FirstDateOfLMP: dueDateForm.FirstDateOfLMP,
            avgCycleDays: parseInt(dueDateForm.avgCycleDays),
            isNewEntry: 1
          };
          break;
    
        case "Ultrasound-Method":
          dueDateForm.ultrasoundDate = pathSegments[1] || "";
          dueDateForm.ultrasoundAge = {
            week: parseInt(pathSegments[2] || "0"),
            days: parseInt(pathSegments[3] || "0")
          };
    
          if (!dueDateForm.ultrasoundDate) return alert("Ultrasound date missing");
    
          body = {
            ultrasoundDate: dueDateForm.ultrasoundDate,
            ultrasoundAge: dueDateForm.ultrasoundAge,
            isNewEntry: 1
          };
          break;
    
        case "IVF-Method":
          dueDateForm.ivftransferDate = pathSegments[1] || "";
          dueDateForm.embryoTransfer = decodeURIComponent(pathSegments[2] || "");
    
          if (!dueDateForm.ivftransferDate) return alert("IVF transfer date missing");
    
          body = {
            ivftransferDate: dueDateForm.ivftransferDate,
            embryoTransfer: dueDateForm.embryoTransfer,
            isNewEntry: 1
          };
          break;
    
        case "Conception-Method":
          dueDateForm.conceptionDate = pathSegments[1] || "";
    
          if (!dueDateForm.conceptionDate) return alert("Conception date missing");
    
          body = {
            conceptionDate: dueDateForm.conceptionDate,
            FirstDateOfLMP: "",
            isNewEntry: 1
          };
          break;
    
        default:
          alert("Unsupported method in URL");
          return;
      }
    
      // 3️⃣ Save to state
      this.setState(
        {
          selectedMethod: method.replace(/-/g, " "),
          dueDateForm
        },
        () => {
          const url = global.api_ci_url + "api/fetchfromCI/duedate~getduedatedetails_v1";
          console.log("📤 Final API Body:", body);
    
          service
            .postServiceCall(url, body)
            .then((json) => {
              console.log("✅ Due Date API Response:", json);
              if (json?.msg == "1") {
                let data = json.result[0];
                if (data && data.length > 0) {
                  this.setState(
                    {
                      dueDate: data.dueDate,
                      pregnancyWeek: data.pregnancyWeek
                    },
                    () => {
                      console.log("📝 Due date state updated");
                    }
                  );
                }
              } else {
                // alert("Unable to calculate due date. Please check input.");
              }
            })
            .catch((err) => {
              console.error("❌ Due Date API Error:", err);
              alert("Something went wrong.");
            });
        }
      );
    
      // 4️⃣ Fetch parenting feed using due date
      const homefeed_url = global.api_ci_url + "api/fetchfromCI/duedate~getpregencyfeed";

      const homefeed_body = {
        dueDate: this.state.dueDate,
        pageNo: "1"
      };
    
      service
        .postServiceCall(homefeed_url, homefeed_body)
        .then((json) => {
          if (json?.msg === "1" && json.result) {
            this.setState({ communityHome: json.result?.communityHome });
            this.setState({ highlights: json.result?.highlights });

            
            console.log("📚 Parenting feed loaded");
          } else {
            console.log("❌ Parenting feed empty or error:");
          }
        })
        .catch((err) => {
          console.error("❌ Parenting feed API error:", err);
          alert("Error loading parenting feed.");
        });
    };
    
      
      
    calculatePregnancyDetails(dueDateStr) {
        console.log("dueDateStr:::", dueDateStr);
        const dueDate = new Date(dueDateStr);

        // const formattedDueDate = dueDate.toLocaleDateString('en-US', {
        //   year: 'numeric',
        //   month: 'long',
        //   day: 'numeric'
        // });
        
        let formattedDueDate = "";
        if (!isNaN(dueDate.getTime())) {
          formattedDueDate = dueDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        } else {
          console.warn("⚠️ Invalid or empty dueDate:", dueDate);
          formattedDueDate = ""; // 👈 blank instead of 'Invalid Date'
        }

        console.log("Formatted Due Date:", formattedDueDate);
        const MS_PER_DAY = 1000 * 60 * 60 * 24;
    
        const today = new Date();

        // Calculate remaining days
        const diffInMs = dueDate - today;
        const remainingDays = Math.max(0, Math.floor(diffInMs / MS_PER_DAY));
        const remainingWeeks = Math.floor(remainingDays / 7);
        const remainingExtraDays = remainingDays % 7;
    
        // Full pregnancy duration = 280 days (40 weeks)
        const totalPregnancyDays = 280;
        const elapsedDays = totalPregnancyDays - remainingDays;
        const currentWeek = Math.floor(elapsedDays / 7);
        const currentDay = elapsedDays % 7;
    
        let trimester = '';
        if (currentWeek <= 12) {
          trimester = '1st Trimester';
        } else if (currentWeek <= 26) {
          trimester = '2nd Trimester';
        } else {
          trimester = '3rd Trimester';
        }
      
        return {
          currentWeek,
          currentDay,
          trimester,
          remainingWeeks,
          remainingExtraDays,
          formattedDueDate
        };
      }

      handleScroll = () => {
        console.log("📦 handleScroll triggered");
      
        const container = this.communityFeedScrollRef.current;
        if (!container) return;
      
        const { scrollTop, scrollHeight, clientHeight } = container;
        console.log({ scrollTop, scrollHeight, clientHeight });
      
        if (
          scrollTop + clientHeight >= scrollHeight - 100 &&
          !this.state.loadingMore &&
          this.state.hasMore
        ) {
          console.log("🚀 Reached near bottom, loading more feed...");
          this.loadMoreFeed();
        }
      };
      
      
      

      loadMoreFeed = () => {
        if (!this.state.hasMore || this.state.loadingMore) return;
      
        this.setState(
          (prevState) => ({
            loadingMore: true,
            pageNo: prevState.pageNo + 1
          }),
          () => {
            const homefeed_url = global.api_ci_url + "api/fetchfromCI/duedate~getpregencyfeed";
            const homefeed_body = {
              dueDate: this.state.dueDate,
              pageNo: this.state.pageNo.toString(),
            };
      
            service
              .postServiceCall(homefeed_url, homefeed_body)
              .then((json) => {
                const communityHome = json.result?.communityHome || [];
                const highlights = json.result?.highlights || [];
              
                if (json?.msg === "1" && Array.isArray(communityHome) && communityHome.length > 0) {
                  this.setState((prevState) => ({
                    communityHome: [...prevState.communityHome, ...communityHome],
                    highlights: [...prevState.highlights, ...highlights],
                    loadingMore: false,
                    hasMore: true
                  }));
                } else {
                  console.log("⚠️ No more data or invalid structure");
                  this.setState({ loadingMore: false, hasMore: false });
                }
              })
              .catch((err) => {
                console.error("❌ Error loading more feed:", err);
                this.setState({ loadingMore: false });
              });
          }
        );
      };
      
      componentWillUnmount() {
        if (this.scrollContainerRef) {
          this.scrollContainerRef.removeEventListener("scroll", this.handleScroll);
        }
      }
            
      
    
    getdueDetails() {
        // let qUrl = this.props.match.url.split('/');
        let qUrl = this.props.location.pathname.split('/');
        console.log("qUrl:::", qUrl);
        let isNewEntry = 1;

        let FirstDateOfLMP;
        let avgCycleDays;
         (qUrl[4] == 0)? FirstDateOfLMP = "" : FirstDateOfLMP = qUrl[4];
         (qUrl[5] == 0)? avgCycleDays = "" : avgCycleDays = qUrl[5];

        var postData = {
                "FirstDateOfLMP": FirstDateOfLMP,
                "avgCycleDays": avgCycleDays,
                "conceptionDate": qUrl[6],
                "isNewEntry": isNewEntry
        }
        var url = global.api_ci_url + "Duedate/getdueDetails";
        service.postServiceCall(url, postData).then((json) => {
            console.log("getdueDetails();::::::",json);
            if (json['result']) {
                this.setState({ initialData: json['result'] }, () => { 
                    // this.landDueDatePage();
                    this.setWidth();                        
                });
                localStorage.setItem('initialData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    // landDueDatePage() {
    //     let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    //     let date = new Date(this.state.displayDate.replace(/-/g,"/"));
    //     this.state.displayDate = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
    //     console.log("this.state.displayDate==========>",this.state.displayDate);
    // }

    // slideStage(e) {
    //     if (e.target.parentElement.classList.contains("next") || e.target.classList.contains("next")) {
    //         e.target.parentElement.parentElement.parentElement.scrollLeft += 480;
    //     } else {
    //         e.target.parentElement.parentElement.parentElement.scrollLeft -= 475;
    //     }
    // }

  slideStage(e) {
    const target = e.target;
    const isNext = target.parentElement.classList.contains("next") || target.classList.contains("next");
    const scrollContainer = target.parentElement.parentElement.parentElement;

    if (!scrollContainer) return;

    // Amount to scroll
    const scrollAmount = isNext ? 480 : -475;

    // Smooth scroll
    scrollContainer.scrollTo({
      left: scrollContainer.scrollLeft + scrollAmount,
      behavior: "smooth"
    });

    // Disable/enable arrows after scroll (wait for smooth scroll to finish)
    setTimeout(() => {
      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

      const arrowsWrapper = target.closest('.arrows');
      if (!arrowsWrapper) return;

      const nextBtn = arrowsWrapper.querySelector('.next');
      const prevBtn = arrowsWrapper.querySelector('.prev');

      if (scrollContainer.scrollLeft >= maxScrollLeft - 2) {
        nextBtn.classList.add("disabled");
      } else {
        nextBtn.classList.remove("disabled");
      }

      if (scrollContainer.scrollLeft <= 2) {
        prevBtn.classList.add("disabled");
      } else {
        prevBtn.classList.remove("disabled");
      }
    }, 400); // Increased delay for smooth scroll
  }

    calculateDueDateAgain() {
        if (!navigator.onLine) {
            service.showAlert("Please check internet connection!!");
        } else {
          let finalQuery = "callAgain=y"
          console.log("finalQuery::==============================:", finalQuery);
          const url1 = service.getRedirectUrl(`/tools/pregnancy-due-date-calculator?${finalQuery}`);
          alert("url is "+url1);
        
        }
    }   

    setPositionofTabs = (dueDate) => {
        // const data = this.props.location?.state?.dueDateData;
        const {
            currentWeek,
            trimester,
           
          } = this.calculatePregnancyDetails(dueDate);
          const numericTrimester = trimester.match(/\d+/)?.[0]; // Extract numeric part of trimester

        console.log("currentWeek@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", currentWeek);
        console.log("trimester@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", trimester);

        const tabs = document.querySelectorAll(".tab_wrap");
        console.log("tabs:::", tabs);
        // console.log("e.target:::", e.target);
        tabs.forEach((tab) => tab.classList.remove("active"));
        tabs[numericTrimester-1].classList.add("active"); // activates Second Trimester tab
      
        const tabText = tabs[numericTrimester-1].textContent.trim().toLowerCase();
        let slideIndex = currentWeek > 40 ? 40 : currentWeek - 1;
        
        if (tabText.includes("2") || tabText.includes("second")) {
          slideIndex = currentWeek -1 ; // 15th week
        } else if (tabText.includes("3") || tabText.includes("third")) {
          slideIndex = currentWeek - 1; // 28th week
        } else if (tabText.includes("1") || tabText.includes("first")) {
          slideIndex =currentWeek == 0 ? 0 : currentWeek - 1; // 28th week
        } 
        else {
          slideIndex = currentWeek -1 ; // 1st week
        }
  
      
        const slides = document.querySelectorAll(".trimester_swipe .swiper-slide");
        console.log("slides:::", slides);
        console.log("slideIndex:::", slideIndex);
        console.log("slides[slideIndex]:::", slides[slideIndex]);
        slides.forEach((slide) => slide.classList.remove("active"));
      
        if (slides[slideIndex]) {
          slides[slideIndex].classList.add("active");
        }
        console.log("slides[slideIndex]::----", slides[slideIndex]);

        console.log("swiperInstance:::", this.swiperInstance);

        const swiper = this.swiperInstance;
        if (!swiper || !swiper.slides) {
          console.warn("Swiper not ready yet.");
          return;
        }      
          // if (tabText.includes("1") || tabText.includes("first")) {
          //   console.log("First trimester active");
          //   //  swiper.slideTo(0, 500);
          //   const targetSlide = swiper.slides[slideIndex];

          //   const offset = targetSlide.offsetLeft; // Align the first slide to the left edge
          //   swiper.setTransition(500);
          //   swiper.setTranslate(-offset);
  
          // } 
          if (tabText.includes("1") || tabText.includes("first")) {
              console.log("First trimester active");

              let targetSlide = swiper.slides[slideIndex];
              let offset = targetSlide.offsetLeft;

              // Detect mobile site (you can tweak width breakpoint if needed)
              let isMsite = window.innerWidth <= 768;

              // Shift amount: msite → 20, desktop → 80
              let shiftAmount = isMsite ? 20 : 80;

              swiper.setTransition(500);

              let newTranslate = -offset + shiftAmount;
              if (offset === 0) {
                newTranslate = shiftAmount;
              }

              swiper.setTranslate(newTranslate);

              setTimeout(() => {
                swiper.setTransition(0);
                swiper.updateProgress();
              }, 500);
        } else if (tabText.includes("2") || tabText.includes("second")) {
            console.log("Second trimester active");
           const targetSlide = swiper.slides[slideIndex];
           console.log("targetSlide::----", targetSlide);

           const offset = targetSlide.offsetLeft - (swiper.width / 2) + (targetSlide.offsetWidth / 2);
      
           swiper.setTransition(500); 
           swiper.setTranslate(-offset);
         
           setTimeout(() => {
             swiper.setTransition(0);
             swiper.updateProgress();
           }, 500);
  
          } else if (tabText.includes("3") || tabText.includes("third")) {
            console.log("Third trimester active");

            let targetSlide = swiper.slides[slideIndex];
            let offset = targetSlide.offsetLeft - (swiper.width - targetSlide.offsetWidth);
              // let offset = targetSlide.offsetLeft;

              // Detect mobile site (you can tweak width breakpoint if needed)
              let isMsite = window.innerWidth <= 768;

              // Shift amount: msite → -20, desktop → -80
              let shiftAmount = isMsite ? -20 : -80;

              swiper.setTransition(500);

              let newTranslate = -offset + shiftAmount;
              if (offset === 0) {
                newTranslate = shiftAmount;
              }

              swiper.setTranslate(newTranslate);

              setTimeout(() => {
                swiper.setTransition(0);
                swiper.updateProgress();
              }, 500);

          //  const targetSlide = swiper.slides[slideIndex];
          //  console.log("targetSlide::----", targetSlide);

          //  const offset = targetSlide.offsetLeft - (swiper.width - targetSlide.offsetWidth);
      
          //   swiper.setTransition(500);
          //   swiper.setTranslate(-offset);
          
          //   setTimeout(() => {
          //     swiper.setTransition(0);
          //     swiper.updateProgress();
          //   }, 500);
      
          }
    };

    initSwipers = () => {
      this.swiperInstance = new Swiper(".trimester_swipe", {
        // loop: true,
        slidesPerView: "auto",
        // autoplay: true,
        //  centeredSlides: true,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
         breakpoints: {
            320: {
                spaceBetween: 10,
            },
             768: {
                spaceBetween: 20,
            },
        },
        // breakpoints: {
        //     320: {
        //         spaceBetween: 10,
        //         slidesPerView:4.3,
        //     },
        //     360: {
        //         spaceBetween: 10,
        //         slidesPerView: 4.8,
        //     },
        //     400: {
        //         spaceBetween: 10,
        //         slidesPerView: 5.3,
        //     },
        //     440: {
        //         spaceBetween: 10,
        //         slidesPerView: 5.4,
        //     },
        //      768: {
        //         spaceBetween: 20,
        //         slidesPerView:5.2
        //     },
        // },
        on: {
            init: () => {
              // Add 'active' to first slide on load
              const firstSlide = document.querySelector(".trimester_swipe .swiper-slide");
              if (firstSlide) firstSlide.classList.add("active");
            },
        },
      });
    };

    checkLoginStatus = (e) => {
        if (!global.ftk) {
          e.preventDefault();       
          e.stopPropagation(); 
            // window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false
        }
        else{
        // const data = this.props.location?.state?.body;
        // const selectedMethod = this.props.location?.state?.selectedMethod || "";
      
        // console.log("data:::>>>>>", data);
      
        // this.setState({
        //   dueDateForm: {
        //     conceptionDate: data.conceptionDate || "",
        //     FirstDateOfLMP: data.FirstDateOfLMP || "",
        //     avgCycleDays: data.avgCycleDays || "",
        //     ultrasoundDate: data.ultrasoundDate || "",
        //     ultrasoundAge: data.ultrasoundAge || "",
        //     ivftransferDate: data.ivftransferDate || "",
        //     embryoTransfer: data.embryoTransfer || "",
        //     // method: selectedMethod
        //   }
        // }, () => {
          // ✅ Now state is updated — safe to use it
          console.log("Due date form state handleConfirmationYes:", this.state.dueDateForm);
      
          const url = global.api_ci_url + "api/fetchfromCI/duedate~saveduedatedata";
          const payload = this.state.dueDateForm;

      
          console.log("Sending to API:", payload);
      
          service.postServiceCall(url, payload).then((res) => {
            console.log("API Success:", res);
            if (res?.msg == "1") {
                // alert("Data saved successfully!");
                console.log("Success")                
                // this.setState({ showConfirmation: false });
              } else {
                // alert("Unable to save data. Please try again.");
                console.warn("API returned failure:", res);
              }
          }).catch((err) => {
            console.error("API Error:", err);
            alert("Failed to save data.");
          });
        // });
        }
      };

      // handleConfirmationYes1 = () => {
      //   if (!global.ftk) {
      //       // window.location.href = global.loginUrl + '?URL=' + global.currentURL;
      //       service.showAlert("Please Login");
      //       window.location.href = global.loginUrl + '?URL=' + global.currentURL + '?login=true';
      //       return false
      //   }
      //   else{
      //   // const data = this.props.location?.state?.body;
      //   // const selectedMethod = this.props.location?.state?.selectedMethod || "";
      
      //   // console.log("data:::>>>>>", data);
      
      //   // this.setState({
      //   //   dueDateForm: {
      //   //     conceptionDate: data.conceptionDate || "",
      //   //     FirstDateOfLMP: data.FirstDateOfLMP || "",
      //   //     avgCycleDays: data.avgCycleDays || "",
      //   //     ultrasoundDate: data.ultrasoundDate || "",
      //   //     ultrasoundAge: data.ultrasoundAge || "",
      //   //     ivftransferDate: data.ivftransferDate || "",
      //   //     embryoTransfer: data.embryoTransfer || "",
      //   //     // method: selectedMethod
      //   //   }
      //   // }, () => {
      //     // ✅ Now state is updated — safe to use it
      //     console.log("Due date form state handleConfirmationYes:", this.state.dueDateForm);
      
      //     const url = global.api_ci_url + "api/fetchfromCI/duedate~saveduedatedata";
      //     const payload = this.state.dueDateForm;

      
      //     console.log("Sending to API:", payload);
      
      //     service.postServiceCall(url, payload).then((res) => {
      //       console.log("API Success:", res);
      //       if (res?.msg == "1") {
      //           alert("Data saved successfully!");
      //           this.setState({ showConfirmation: false });
      //         } else {
      //           alert("Unable to save data. Please try again.");
      //           console.warn("API returned failure:", res);
      //         }
      //     }).catch((err) => {
      //       console.error("API Error:", err);
      //       alert("Failed to save data.");
      //     });
      //   // });
      //   }
      // };
      
      
      // handleConfirmationNo = () => {
      //   this.setState({ showConfirmation: false });
      // };

      // checkLoginStatus1 = (e) => {
      //   if (!global.ftk) {
      //     e.preventDefault();
      //     e.stopPropagation(); // prevents links inside CommunityFeed from firing
      //     // this.setState({ showConfirmation: true });
      //   }
      // }
      
      
      
      
      
      


    render() {
    const {dueDate, selectedMethod, pregnancyWeek , communityHome,highlights} = this.state;
    // console.log("dueDate inside render:::", dueDate);
    // console.log("Feed inside render:::", communityHome);
    // console.log("highlights inside render:::", highlights);

    const {
      currentWeek,
      currentDay,
      trimester,
      remainingWeeks,
      remainingExtraDays,
      formattedDueDate
    } = this.calculatePregnancyDetails(dueDate);
    console.log("currentWeek:::", currentWeek);
    console.log("currentDay:::", currentDay);
    console.log("trimester:::", trimester);
    console.log("remainingWeeks:::", remainingWeeks);
    console.log("remainingExtraDays:::", remainingExtraDays);
    console.log("formattedDueDate:::", formattedDueDate);
    const numericTrimester = trimester.match(/\d+/)?.[0]; // Extract numeric part of trimester

         const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
        return (
            <main className="duedate-tool main-container">
                <Helmet
                    title="Pregnancy Due Date Calculator - Estimate and Predict Your Date of Delivery"
                    meta={[
                        { "name": "description", "content": "Calculate your baby's due date with our accurate Pregnancy Due Date Calculator. Plan ahead for your special day with ease and confidence." },
                        { "name": "keywords", "content": "due date calculator, pregnancy due date calculator" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                {/* {isMobile ? (
                    <div className="due_ms_header">
                        <div className="ms_header_name">
                            <a href="#"><span className="arrow-icon" data-icon-font="s"></span></a>
                            <span className="M17_21">Due Date Calculator</span>
                        </div>
                    </div>
                ):( */}
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Due Date Calculator</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Pregnancy Due Date Calculator</h1>
                </div>
                {/* )} */}
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="trimester_page_wrap">
                            <div className="duedate_banner">
                                <div className="inner_white_bg">
                                    <div className="calendar_icon"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_pink_cal.svg" /></div>
                                    <div className="ur_due_date">Your due date</div>
                                    <div className="due_date_show"  
                                    >{formattedDueDate}</div>
                                    <div className="heart_bg_img"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_heart_bg.svg" /></div>
                                </div>
                                <div className="rem_days_text">
                                <span>
                                    Only {remainingWeeks} Weeks
                                    {remainingExtraDays !== 0 && ` ${remainingExtraDays} Days`} left until your baby is born!
                                </span>
                                    <a href="/tools/pregnancy-due-date-calculator/?callAgain=y" id="calculate-again">Calculate Again</a>
                                </div>
                            </div>
                            <div className="trimester_sec_wrap">
                            <div className="trimester_tabs_wrap">
                              <div
                                className={`tab_wrap ${trimester.startsWith('1') ? 'active' : ''}`}
                                // onClick={(e) => this.handleTabClick(e, currentWeek, 1)}
                              >
                                {isMobile ? "1st" : "First"} Trimester
                              </div>

                              <div
                                className={`tab_wrap ${trimester.startsWith('2') ? 'active' : ''}`}
                                // onClick={(e) => this.handleTabClick(e, currentWeek, 2)}
                              >
                                {isMobile ? "2nd" : "Second"} Trimester
                              </div>

                              <div
                                className={`tab_wrap ${trimester.startsWith('3') ? 'active' : ''}`}
                                // onClick={(e) => this.handleTabClick(e, currentWeek, 3)}
                              >
                                {isMobile ? "3rd" : "Third"} Trimester
                              </div>
                            </div>


                                <div className="trimester_slider_wrap">
                                    <div className="swiper-container trimester_swipe">
                                        <div className="swiper-wrapper"> 
                                            {Array.from({ length: 40 }).map((_, index) => (
                                             <div className="swiper-slide" key={index}>
                                                <div className="week_box_wrap">
                                                    <div className="week_num">{index + 1}</div>
                                                    <div className="sub_text">Week Pregnant</div>
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                        <div className="swiper-pagination"></div>
                                    </div>
                                </div>
                           

                            </div>
                            {this.state.articlesData && this.state.articlesData !=[] && this.state.articlesData.length > 0 &&
                            
                            <div className="duedatedetail-container duedatedetail" style={{ display:"none"}}>
                            <div className="duedatedetail-date" style={{ display:"none"}}>
                                <span className="icon calendar-icon" data-icon-font="w"></span>
                                <div id="dueCurrentDate" className="R14_9e">
                                    {this.state.displayDate}
                                </div>
                                {
                                    this.state.avgCycleDays != "" && this.state.avgCycleDays != 0 ?
                                        (<div>
                                            <div className="R14_9e"> | </div>
                                            <div className="R14_9e">
                                                {this.state.avgCycleDays} Days </div>
                                        </div>
                                        ) : null
                                }
                            </div>
                            {this.state.articlesData && this.state.articlesData !=[] && this.state.articlesData.length > 0 && this.state.articlesData.map((result, index) => result.index == 1 ?
                                (<div key={index} className="duedatedetail-block">
                                    <div className="duedatedetail-smiley">
                                        <div data-icon-font="&#xe04a;" className="icon" ></div>
                                    </div>
                                    <div className="duedatedetail-data">
                                        <div className="duedatedetail-congo">
                                            <span>Congratulations!</span>
                                        </div>
                                        <div className="duedatedetail-msg">
                                            <span>{result.question} <b> {result.date}</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                ) :

                                (
                                    <div key={index}>
                                        <div className={"duedatedetail-article article_" + result.index} data-id={result.index}>
                                            <div className="duedatedetail-dates">
                                                <div className="duedatedetail-dtitle">
                                                    <span className="M15_42">{result.question}</span>
                                                </div>
                                                <div className="duedatedetail-odate">
                                                    <div className="R13_75">{result.date}</div>
                                                </div>
                                            </div>
                                            <div className="duedate-slider">
                                                <ul className="slider fl">
                                                    {this.state.articlesData && result.article.map((article, index1) =>
                                                        <li key={index1} className="slide" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                            <a href={article['articleUrl']}>
                                                                <div className="duedate-article" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)} data-id={article['articleId']}>
                                                                    <div className="duedate-img ddcArticleClick" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                                        <img className="entry-thumb ddcArticleClick td-animation-stack-type0-2" src={article['articleImage'].replace("http://", "https://", article['articleImage'])} alt={article['articleTitle']} title={article['articleTitle']} id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)} />
                                                                    </div>
                                                                    <div className="duedate-acontent ddcArticleClick" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                                        <span className="R14_42 ddcArticleClick" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                                            {article.articleTitle}
                                                                        </span>
                                                                        <div className="readmorelink R14_link" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>Read More</div>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>
                                                    )}
                                                </ul>
                                                <div className="arrows">
                                                    <span className="next" onClick={(e) => { this.slideStage(e) }}><span data-icon-font="h" className="icon"></span></span>
                                                    <span className="prev disabled" onClick={(e) => { this.slideStage(e) }}><span data-icon-font="g" className="icon"></span></span>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="divider_line" style={{display:"none"}}></div>
                                    </div>
                                ))}


                             {/* <div id="duedateCalBtn" className="askB_1 calculateAgain" onClick={() => { this.calculateDueDateAgain() }}>
                                <p title="Calculate  My Due Date" className="clcdueagain">
                                    <span className="clcdueagain">CALCULATE AGAIN</span>
                                </p>
                            </div> */}
                            {/*<div className="duedate-btn-block duedatedetail-obtn">
                                <div className="duedate-btn faq faqDisclaimer">
                                    <div id="duedateBtn" data-id="ios" className="faqperiodbtn" onClick={() => { actions.FAQs(this) }}>
                                        <p title="Period & Ovulation FAQs">
                                            <span className="M14_9e textdata">FAQs</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="duedate-btn disclaimer">
                                    <div id="duedateBtn" data-id="ios" className="faqperiodbtn" onClick={() => { actions.Disclaimer(this) }}>
                                        <p title="Period & Ovulation Disclaimer">
                                            <span className="M14_9e textdata">Disclaimer</span>
                                        </p>
                                    </div>
                                </div>
                            </div> */}
                            {/* <FaqsDisclaimer eleRef={this} /> */}
                        </div>
                        }

                           {this.state.highlights && this.state.highlights.length > 0 ?
                            (<section className="highlight_the_week_main_div" 
                            ref={this.highlightsScrollRef}
                            onScroll={this.handleScroll()} 
                            onClick={(e) => this.checkLoginStatus(e)}>
                                <div className="highlited_heading_text"> Highlights of the Week</div>
                                <HowFeed highlightsfeed={this.state.highlights} eleRef={this} />
                            </section>):''
                            }

                            <div className="main_div_three_and_four_view desktop_checkout_popular_view">
                            <div className="main_div_three_and_four_style" 
                            ref={this.communityFeedScrollRef}
                            onScroll={this.handleScroll()} 
                            onClick={(e) => this.checkLoginStatus(e)}>
                            <CommunityFeed highlightsfeed={communityHome} eleRef={this}  />                                    
                            </div>
                            </div>


                        </div>
                        {/* {this.state.showConfirmation && (
                          <div className="confirmation_pop_overlay">
                            <div className="confirm_pop_body">
                              <div className="save_info">Do you want to save this information?</div>
                              <div className="buttons_wrap">
                                <div className="btn yes_btn" onClick={this.handleConfirmationYes}>Yes</div>
                                <div className="btn no_btn" onClick={this.handleConfirmationNo}>No</div>
                              </div>
                            </div>
                          </div>
                        )} */}

                       

                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withLocation(DueDateDetails);
